<template>
    <div v-if="sliders">
        <div class="row stones-tabs-row">
            <div class="w-100">
                <b-tabs content-class="mt-3" align="center">
                    <b-tab @click="labgrown = false; buildQuery()" :active="!labgrown">
                        <template #title>
                            <strong>{{ $t('stones.natural') }}</strong>
                        </template>
                    </b-tab>
                    <b-tab @click="labgrown = true; buildQuery()" :active="labgrown">
                        <template #title>
                            <strong>{{ $t('stones.labgrown') }}</strong>
                        </template>
                    </b-tab>
                </b-tabs>
            </div>
        </div>
        <form @submit.prevent="buildQuery()" class="stone-filters">
            <div class="white-fancy-row row">
                <div class="col-12">
                    <b-form-radio-group class="w-100 white-fancy-btn" id="white-fancy-btn" v-model="fancy"
                        button-variant="primary" buttons>
                        <b-form-radio :value="false">{{ $t('stones.white') }}</b-form-radio>
                        <b-form-radio :value="true">{{ $t('stones.fancy') }} <span
                                class="new-feature"></span></b-form-radio>
                    </b-form-radio-group>
                </div>
            </div>
            <div class="row bg-white" v-if="fancy">
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.fancyColor') }}</label>
                    <v-select :placeholder="$t('stones.selectFancyColor')" multiple v-model="selectedFancyColor"
                        :options="fancyColorOptions">
                    </v-select>
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.fancyOvertone') }}</label>
                    <v-select :placeholder="$t('stones.selectFancyOvertone')" multiple v-model="selectedFancyOvertone"
                        :options="fancyOvertoneOptions" />
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.fancyIntensity') }}</label>
                    <v-select :placeholder="$t('stones.selectFancyIntensity')" multiple v-model="selectedFancyIntensity"
                        :options="fancyIntensityOptions" />
                </div>
            </div>
            <div class="filters-row row">
                <div class="col-md-6 col-lg-4 col-filter shape-filter">
                    <label class="filter-label">{{ $t('stones.shape') }}</label>
                    <div class="stone-shape" :class="{ 'active': shape.active }" v-for="shape of shapes"
                        :key="shape.value" @click="selectShape(shape)">
                        <img :src="getShapeImage(shape)" />
                        <div class="shape-name">{{ shape.value }}</div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.carat') }}</label>
                    <vue-slider v-model="sliders.carat.value" :min="sliders.carat.min" :max="sliders.carat.max"
                        :marks="sliders.carat.marks" :interval="sliders.carat.step" :railStyle="railStyle"
                        :process-style="processStyle" :drag-on-click="true" :tooltip-formatter="ctFormatter"
                        :dot-options="dotOptions" :data="caratData">
                    </vue-slider>
                    <div>
                        <div class="input-icon input-icon-right">
                            <input step="0.05" :min="sliders.carat.min" value='0.00' class="form-control" type="number"
                                v-model.lazy="sliders.carat.value[0]" />
                            <i>{{ $t('ct') }}</i>
                        </div>
                        <div class="input-icon input-icon-right float-right">
                            <input step="0.05" value='0.00' class="form-control" type="number"
                                v-model.lazy="sliders.carat.value[1]" />
                            <i>{{ $t('ct') }}</i>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-4 col-filter" v-if="!fancy">
                    <label class="filter-label">{{ $t('stones.color') }}</label>
                    <vue-slider v-model="sliders.color.value" :step-style="{ 'background-color': '#FFF' }"
                        :railStyle="railStyle" :process-style="processStyle" :data="sliders.color.data" :marks="true"
                        :drag-on-click="true" :dot-options="dotOptions">
                    </vue-slider>
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.clarity') }}</label>
                    <vue-slider v-model="sliders.clarity.value" :step-style="{ 'background-color': '#FFF' }"
                        :railStyle="railStyle" :process-style="processStyle" :data="sliders.clarity.data" :marks="true"
                        :drag-on-click="true" :dot-options="dotOptions">
                    </vue-slider>
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.cut') }}</label>
                    <vue-slider v-model="sliders.cut.value" :step-style="{ 'background-color': '#FFF' }"
                        :railStyle="railStyle" :process-style="processStyle" :marks="true" :data="sliders.cut.data"
                        :data-value="'name'" :data-label="'name'" :drag-on-click="true" :dot-options="dotOptions">
                    </vue-slider>
                </div>
                <div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.fluorescence') }}</label>
                    <vue-slider v-model="sliders.fluorescence.value" :step-style="{ 'background-color': '#FFF' }"
                        :railStyle="railStyle" :process-style="processStyle" :marks="true"
                        :data="sliders.fluorescence.data" :data-value="'name'" :data-label="'name'"
                        :drag-on-click="true" :dot-options="dotOptions">
                    </vue-slider>
                </div>
                <!--<div class="col-md-6 col-lg-4 col-filter">
                    <label class="filter-label">{{ $t('stones.price') }}</label>
                    <vue-slider v-model="sliders.price.value" :min="sliders.price.min" :max="sliders.price.max"
                        :marks="sliders.price.marks" :interval="sliders.price.step" :railStyle="railStyle"
                        :process-style="processStyle" :drag-on-click="true" :tooltip-formatter="priceFormatter"
                        :dot-options="dotOptions">
                    </vue-slider>
                </div>-->
                <div class="col-md-6 col-lg-4 col-filter shape-filter">
                    <label class="filter-label">{{ $t('stones.certificateLab') }}</label>
                    <div class="form-check form-check-inline custom-checkbox" v-for="certLab of certificateLab"
                        :key="certLab">
                        <input class="form-check-input custom-control-input" type="checkbox"
                            :id="'inlineCheckbox' + certLab" :value="certLab" v-model="certificateLabFilter">
                        <label class="form-check-label custom-control-label" :for="'inlineCheckbox' + certLab">{{
        certLab
    }}</label>
                    </div>
                </div>
                <div class="col-md-12 offset-lg-4 col-lg-4 d-flex" :class="fancy ? 'col-lg-8' : 'col-lg-4'">
                    <div class="apply-btn-div">
                        <button type="submit" class="apply-btn btn btn-primary">{{ $t("apply") }}</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="filter-tags-row row">
            <div class="col-12">
                <div class="filter-tag" v-for="filter of filterTags">
                    <span class="label">{{ filter.name + (filter.value ? ': ' + filter.value : '') }}</span>
                    <span class="remove-filter-icon" @click="resetFilter(filter)">
                        <font-awesome-icon :icon="['fa', 'times']" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import { mapActions, mapState, mapGetters } from "vuex";
import buildYourJewel from "../api/build-your-jewel";
import Vue from "vue";

export default {
    name: "StoneFilters",
    props: {
        buildYourJewelMode: String,
    },
    data() {
        return {
            railStyle: {
                'height': '10px'
            },
            processStyle: {
                'background-color': window.getComputedStyle(document.documentElement).getPropertyValue('--primary-color-1')
            },
            sliders: {
                color: {
                    default: ['D', 'I'],
                    value: ['D', 'I'],
                    data: ['D', 'E', 'F', 'G', 'H', 'I']
                },
                carat: {
                    default: [this.buildYourJewelMode ? 0.20 : 0.50, 2],
                    value: [this.buildYourJewelMode ? 0.20 : 0.50, 2],
                    step: 0.05,
                    min: this.buildYourJewelMode ? 0.20 : 0.50,
                    max: 8,
                    marks: { /*0: { label: "0 ct" }, 30: { label: "30 ct" } */ }
                },
                clarity: {
                    default: ['FL', 'SI2'],
                    value: ['FL', 'SI2'],
                    data: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2']
                },
                cut: {
                    default: ['Good', 'Ideal'],
                    value: ['Good', 'Ideal'],
                    data: [{ name: this.$t("stones.quality.GD"), value: 'GD' }, { name: this.$t("stones.quality.VG"), value: 'VG' }, { name: this.$t("stones.quality.EX"), value: 'EX' }, { name: this.$t("stones.quality.ID"), value: 'ID' }]
                },
                fluorescence: {
                    default: [this.$t("stones.fluorescence.NON"), this.$t("stones.fluorescence.VST")],
                    value: [this.$t("stones.fluorescence.NON"), this.$t("stones.fluorescence.VST")],
                    data: [{ name: this.$t("stones.fluorescence.NON"), value: 'NON' }, { name: this.$t("stones.fluorescence.FNT"), value: 'FNT' }, { name: this.$t("stones.fluorescence.MED"), value: 'MED' }, { name: this.$t("stones.fluorescence.STG"), value: 'STG' }, { name: this.$t("stones.fluorescence.VST"), value: 'VST' }]
                },
                price: {
                    default: [0, 3000000], value: [0, 3000000], step: 10, min: 0, max: 3000000, marks: { 0: { label: "0 €" }, 3000000: { label: "3M €" } }
                },
            },
            dotOptions: {
                tooltipStyle: {
                    background: window.getComputedStyle(document.documentElement).getPropertyValue('--primary-color-1'),
                    'border-color': window.getComputedStyle(document.documentElement).getPropertyValue('--primary-color-1'),
                }
            },
            certificateLabFilter: [],
            selectedFancyColor: [],
            selectedFancyIntensity: [],
            selectedFancyOvertone: [],
            labgrown: false,
            fancy: false,
            filterTags: [],
            buildYourJewelStoneShapes: []
        }
    },
    computed: {
        ...mapGetters("stones", ["getQuery"]),
        ...mapState({
            stateShapes: (state) => state.stones.shapes,
            fancyOvertoneOptionKeys: (state) => state.stones.fancyOvertoneOptions,
            fancyColorOptionKeys: (state) => state.stones.fancyColorOptions,
            fancyIntensityOptionKeys: (state) => state.stones.fancyIntensityOptions,
            certificateLab: (state) => state.stones.certificateLab,
            searchJewel: (state) => state.list.searchJewel,
            credential: (state) => state.config.credential,
            isPluginB2C: (state) => state.config.isPluginB2C,
        }),
        fancyOvertoneOptions: function () {
            return this.fancyOvertoneOptionKeys.map(o => ({ value: o.value, label: this.$t(o.key) }))
        },
        fancyColorOptions: function () {
            return this.fancyColorOptionKeys.map(o => ({ value: o.value, label: this.$t(o.key) }))
        },
        fancyIntensityOptions: function () {
            return this.fancyIntensityOptionKeys.map(o => ({ value: o.value, label: this.$t(o.key) }))
        },
        shapes: function () {
            return this.buildYourJewelMode ? this.buildYourJewelStoneShapes : this.stateShapes
        },
        caratPoints: function () {
            return [
                {
                    value: this.buildYourJewelMode ? 0.20 : 0.50,
                    step: 0.05,
                },
                {
                    value: 3,
                    step: 1,
                },
                {
                    value: 8,
                    step: 5,
                }
            ];
        },
        caratData: function () {
            let result = [];

            this.caratPoints.forEach((point, idx) => {
                const lastPointValue = this.caratPoints[this.caratPoints.length - 1].value;

                if (point.value === lastPointValue) {
                    return;
                } else {
                    const nextPoint = this.caratPoints[idx + 1];

                    for (let i = point.value; i <= nextPoint.value; i += point.step) {
                        const roundedValue = parseFloat(i.toFixed(2));
                        result.push(roundedValue);
                    }
                }
            });

            const uniqueValues = new Set(result);
            return [...uniqueValues];
        },
    },
    methods: {
        ctFormatter(number) {
            return this.$options.filters.number(parseFloat(number), '0.00') + ' ' + this.$t('ct');
        },
        priceFormatter(number) {
            return this.$options.filters.currency(number, '€', 0);
        },
        ...mapActions("stones", [
            "setQuery",
        ]),
        buildQuery(skipSave) {
            let query = {};
            query.labgrown = this.labgrown;
            query.fancy = this.fancy;
            if (query.fancy) {
                query.color = ['FANCY'];
                query.fancyColor = this.selectedFancyColor.map(item => item.value);
                query.fancyIntensity = this.selectedFancyIntensity.map(item => item.value);
                query.fancyOvertone = this.selectedFancyOvertone.map(item => item.value);
            } else {
                query.color = this.sliders.color.data.slice(this.sliders.color.data.indexOf(this.sliders.color.value[0]), this.sliders.color.data.indexOf(this.sliders.color.value[1]) + 1);
            }
            query.clarity = this.sliders.clarity.data.slice(this.sliders.clarity.data.indexOf(this.sliders.clarity.value[0]), this.sliders.clarity.data.indexOf(this.sliders.clarity.value[1]) + 1);
            query.sizes = [{ from: this.sliders.carat.value[0], to: this.sliders.carat.value[1] }];
            query.cut = this.sliders.cut.data.slice(this.sliders.cut.data.findIndex((obj) => obj.name == this.sliders.cut.value[0]), this.sliders.cut.data.findIndex((obj) => obj.name == this.sliders.cut.value[1]) + 1).map(item => item.value);
            // CUT -> G e GD sono equivalenti -> good
            if (query.cut.includes("GD"))
                query.cut.push("G")

            query.fluorescence = this.sliders.fluorescence.data.slice(this.sliders.fluorescence.data.findIndex((obj) => obj.name == this.sliders.fluorescence.value[0]), this.sliders.fluorescence.data.findIndex((obj) => obj.name == this.sliders.fluorescence.value[1]) + 1).map(item => item.value);
            // FLUORESCENCE STG e STN sono equivalenti -> strong
            if (query.fluorescence.includes("STG"))
                query.fluorescence.push("STN")

            query.price = { from: this.sliders.price.value[0], to: this.sliders.price.value[1] };
            query.shapes = this.shapes.filter(s => s.active).map(s => s.value);
            query.certificate_lab = [...this.certificateLabFilter];
            query.order = { type: query.fancy ? 'price' : 'discount', direction: "ASC" }
            this.setQuery(query);
            this.filterTags = this.buildfilterTags();

            if (!skipSave)
                this.saveFiltersToLocalStorage(query);

            // Escludi dai risultati le pietre gia' nel carrello (via handleCartInfo -> filter_ids).
            // Solo gli host B2B (shop-b2b, supplier-fe) rispondono a getGioielleriaItalianaBasket:
            // nel plugin B2C dei gioiellieri la risposta non arriva mai, quindi si cerca subito.
            if (window.parent !== window && !this.isPluginB2C) {
                Vue.getBasket();
            } else {
                this.$emit("changeFilters");
            }
        },
        saveFiltersToLocalStorage(queryObj) {
            queryObj.cut = queryObj.cut.filter(c => c!= "G");
            queryObj.fluorescence = queryObj.fluorescence.filter(f => f != "STN");
            localStorage.setItem(this.buildYourJewelMode? 'byjDiamondFilters' : 'diamondFilters', JSON.stringify(queryObj));
        },
        restoreFiltersFromLocalStorage() {
            const savedFilters = localStorage.getItem(this.buildYourJewelMode? 'byjDiamondFilters' : 'diamondFilters');
            if (savedFilters) {
                const savedFiltersObj = JSON.parse(savedFilters);
                this.labgrown = savedFiltersObj.labgrown;
                this.fancy = savedFiltersObj.fancy;
                if (savedFiltersObj.fancy) {
                    this.selectedFancyColor = this.fancyColorOptions.filter(opt => savedFiltersObj.fancyColor.includes(opt.value));
                    this.selectedFancyIntensity = this.fancyIntensityOptions.filter(opt => savedFiltersObj.fancyIntensity.includes(opt.value));
                    this.selectedFancyOvertone = this.fancyOvertoneOptions.filter(opt => savedFiltersObj.fancyOvertone.includes(opt.value));
                } else {
                    this.sliders.color.value = [
                        this.sliders.color.data.find(obj => obj === savedFiltersObj.color[0]),
                        this.sliders.color.data.find(obj => obj === savedFiltersObj.color[savedFiltersObj.color.length - 1])
                    ];
                }
                this.sliders.clarity.value = [
                    this.sliders.clarity.data.find(obj => obj === savedFiltersObj.clarity[0]),
                    this.sliders.clarity.data.find(obj => obj === savedFiltersObj.clarity[savedFiltersObj.clarity.length - 1])
                ];
                this.sliders.carat.value = [savedFiltersObj.sizes[0].from, savedFiltersObj.sizes[0].to];
                this.sliders.cut.value = [
                    this.sliders.cut.data.find(obj => obj.value === savedFiltersObj.cut[0]).name,
                    this.sliders.cut.data.find(obj => obj.value === savedFiltersObj.cut[savedFiltersObj.cut.length - 1]).name
                ];
                this.sliders.fluorescence.value = [
                    this.sliders.fluorescence.data.find(obj => obj.value === savedFiltersObj.fluorescence[0]).name,
                    this.sliders.fluorescence.data.find(obj => obj.value === savedFiltersObj.fluorescence[savedFiltersObj.fluorescence.length - 1]).name
                ];
                this.sliders.price.value = [savedFiltersObj.price.from, savedFiltersObj.price.to];
                this.shapes.forEach(shape => {
                    shape.active = savedFiltersObj.shapes.includes(shape.value);
                });
                this.certificateLabFilter = savedFiltersObj.certificate_lab;
                this.buildQuery(true);
            } else
                this.buildQuery();
        },
        buildfilterTags() {
            let tags = [];

            if (this.shapes.filter(s => s.active).length > 0) {
                tags.push({ key: 'shape', name: this.$t('stones.shape'), value: this.shapes.filter(s => s.active)[0].value })
            }

            if (this.certificateLabFilter.length > 0) {
                tags.push({ key: 'certificateLab', name: this.$t('stones.certificateLab'), value: this.certificateLabFilter.join(", ") })
            }

            if (this.fancy) {
                if (this.selectedFancyColor.length > 0) {
                    tags.push({ key: 'selectedFancyColor', name: this.$t('stones.fancyColor'), value: this.selectedFancyColor.map(item => item.label).join(", ") })
                }
                if (this.selectedFancyIntensity.length > 0) {
                    tags.push({ key: 'selectedFancyIntensity', name: this.$t('stones.fancyIntensity'), value: this.selectedFancyIntensity.map(item => item.label).join(", ") })
                }
                if (this.selectedFancyOvertone.length > 0) {
                    tags.push({ key: 'selectedFancyOvertone', name: this.$t('stones.fancyOvertone'), value: this.selectedFancyOvertone.map(item => item.label).join(", ") })
                }
            }

            for (var key in this.sliders) {
                if (!this.sliders[key].value.every((value, index) => value === this.sliders[key].default[index])) {
                    let value = this.sliders[key].value[0] + '-' + this.sliders[key].value[1];
                    if (key == 'price')
                        value = this.priceFormatter(this.sliders[key].value[0]) + '-' + this.priceFormatter(this.sliders[key].value[1]);
                    else if (key == 'carat')
                        value = this.ctFormatter(this.sliders[key].value[0]) + '-' + this.ctFormatter(this.sliders[key].value[1]);

                    if (!this.fancy || key != 'color')
                        tags.push({ key: key, name: this.$t('stones.' + key), value: value })
                }
            }

            if (tags.length > 0)
                tags.push({ key: 'all', name: this.$t('Clear all') })
            return tags;
        },
        getShapeImage(shape) {
            return require('../assets/stone_shape/' + shape.value + '.png');
        },
        selectShape(shape) {
            this.shapes.forEach(s => {
                if (shape.value != s.value) s.active = false;
            });
            shape.active = !shape.active;
        },
        resetFilter(filter, skipRefresh) {
            if (filter.key == 'all') {
                this.resetAllFilters();
                return;
            }
            if (filter.key == 'shape') {
                this.shapes.forEach((s) => { s.active = false });
            }
            else if (filter.key == 'certificateLab') {
                this.certificateLabFilter = [];
            }
            else if (filter.key == 'selectedFancyColor' || filter.key == 'selectedFancyIntensity' || filter.key == 'selectedFancyOvertone') {
                this[filter.key] = [];
            }
            else
                this.sliders[filter.key].value = [...this.sliders[filter.key].default];

            if (!skipRefresh)
                this.buildQuery();
        },
        resetAllFilters() {
            this.shapes.forEach((s) => { s.active = false });
            this.certificateLabFilter = [];
            this.selectedFancyColor = [];
            this.selectedFancyIntensity = [];
            this.selectedFancyOvertone = [];
            for (var key in this.sliders) {
                this.resetFilter({ key }, true);
            }
            this.buildQuery();
        },
        handleCartInfo(event) {
            if (event.data.func === 'responseGioielleriaItalianaBasket') {
                const cartItems = event.data.cartItems;

                const stoneItemIds = cartItems
                    .filter(item => item.productType === 'STONE' || item.productType === 'LABGROWN_STONE')
                    .map(item => item.sku.replace('DIAMOND/', ''));
                    

                const bundleItemIds = cartItems
                    .flatMap(item => item.bundleItems || [])
                    .filter(bundleItem => bundleItem.productType === 'STONE' || bundleItem.productType === 'LABGROWN_STONE')
                    .map(bundleItem => bundleItem.sku.replace('DIAMOND/', ''));

                // Combine both sets of filter IDs
                const filter_ids = [...stoneItemIds, ...bundleItemIds];

                this.setQuery({ ...this.getQuery, filter_ids });
                console.log('Received cart info from parent:', cartItems);
                this.$emit("changeFilters");
            }
        }
    },
    mounted() {
        if (this.buildYourJewelMode) {
            buildYourJewel.getStoneFilters().then((response) => {
                this.buildYourJewelStoneShapes = response.data.shapes.map(s => {
                    return { value: s, active: this.searchJewel.stoneShape == s }
                })

                this.restoreFiltersFromLocalStorage();
            });
        }
        else
            //start diamonds search
            this.restoreFiltersFromLocalStorage();

        window.addEventListener('message', this.handleCartInfo, false);
    },
    destroyed() {
        window.removeEventListener('message', this.handleCartInfo, false);
    }
}

</script>

<style lang="scss" scoped>
.filters-row {
    background-color: #fff;
    padding-bottom: 2em;
}

.col-filter {
    text-align: left;
    padding: 20px 40px 30px;
}

.shape-filter {
    padding-bottom: 0;
}

.filter-label {
    font-weight: bold;
    display: block;
}

.vue-slider-marks::v-deep {
    .vue-slider-mark-step {
        background-color: white !important;
    }
}

.stone-filters {
    background-color: #fff;
}

.stone-shape {
    border: 1px solid gray;
    border-radius: 5px;
    cursor: pointer;
    padding: 3px 0px;
    margin-right: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
    display: inline-block;
    text-align: center;
    width: 65px;
    height: 32px;
    overflow: hidden;

    &.active {
        border: 2px solid var(--primary-color-1);
    }

    &:hover {
        .shape-name {
            display: inline-block;
        }

        img {
            display: none;
        }
    }

    .shape-name {
        font-size: 10px;
        font-weight: bold;
        line-height: 22px;
        display: none;
    }

    img {
        height: 24px;
        display: inline-block;
    }
}

.filter-tags-row {
    padding-top: 15px;
    font-size: 12px;
    text-align: left;
}

.filter-tag {
    background-color: var(--secondary-color-1) !important;
    color: var(--primary-color-1);
    padding: 8px;
    margin-right: 10px;
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 5px;

    .label {
        margin-right: 10px;
    }

    .remove-filter-icon {
        cursor: pointer;
    }
}

.input-icon {
    max-width: 95px;
    margin-top: 5px;
    position: relative;
    display: inline-block;
}

.input-icon>i {
    position: absolute;
    display: block;
    transform: translate(0, -50%);
    top: 50%;
    pointer-events: none;
    width: 25px;
    text-align: center;
    font-style: normal;
}

.input-icon>input {
    padding-left: 25px;
    padding-right: 0;
}

.input-icon-right>i {
    right: 0;
    font-size: 14px;
}

.input-icon-right>input {
    padding-left: 0;
    padding-right: 25px;
    font-size: 14px;
    text-align: right;
}

.form-check-inline {
    margin-right: 2rem;
}

.apply-btn {
    background-color: var(--primary-color-1) !important;
    color: white !important;
    text-transform: uppercase;
}

.apply-btn-div {
    margin-top: auto;
    width: 100%;
    text-align: right;
}

.tabs::v-deep {
    width: 100%;

    .nav-tabs .nav-link.active,
    .nav-tabs .nav-item.show .nav-link {
        font-weight: bold;
        color: var(--primary-color-1);
        background-color: #fff;
        //border: 2px;
        border-color: var(--primary-color-1) var(--primary-color-1) #fff;
    }

    .nav-tabs {
        border-bottom: 1px solid var(--primary-color-1);

        a {
            text-transform: uppercase;
            color: var(--primary-color-1);
        }
    }
}

.stones-tabs-row {
    background-color: white;
}

.white-fancy-row {
    background-color: white;
}

.white-fancy-btn::v-deep {
    .btn-primary.active {
        background-color: var(--primary-color-1) !important;
        border-color: var(--primary-color-1) !important;
        color: white !important;
    }

    .btn-primary {
        border-color: var(--primary-color-1);
        color: var(--primary-color-1);
        background-color: white;
        border-radius: 0;
        text-transform: uppercase;

        &:hover {
            background-color: var(--secondary-color-1);
        }

        &.focus {
            box-shadow: none;
        }
    }


}

.custom-checkbox {
    .custom-control-label {
        cursor: pointer;
    }

    .custom-control-label:before {
        background-color: white;
    }

    .custom-control-input:checked~.custom-control-label::before {
        border-color: var(--primary-color-1);
        background-color: var(--primary-color-1);
    }

    /*.custom-control-input:checked~.custom-control-label::after {
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='red' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
    }
    .custom-control-input:focus~.custom-control-label::before {
        box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(0, 39, 79, 0.25);
    }*/
}

.stones-tabs-row::v-deep {
    ul {
        background-color: #F0F0EF;
        padding-top: 10px;
    }

}

.v-select::v-deep {
    --vs-controls-color: var(--primary-color-1);
    --vs-border-color: var(--primary-color-1);
    --vs-dropdown-color: var(--primary-color-1);
    --vs-dropdown-option-color: var(--primary-color-1);
    --vs-controls-color: rgba(255, 255, 255, 0.5);
    --vs-selected-bg: var(--primary-color-1);
    --vs-selected-color: #eeeeee;
    --vs-dropdown-option--active-bg: var(--secondary-color-1);
    --vs-dropdown-option--active-color: var(--primary-color-1);

    .vs__deselect {
        background-color: transparent !important;
    }
}

</style>